var xP = require('../xP')
  , $ = require('jquery');

module.exports = {
  name: '_field', base: '_parent', prototype: {
    element_selector: 'input',
    container_selector: '.field',

    init: function (params) {
      xP.controls._field.base.init.apply(this, arguments);

      var that = this;

      this.$element.bind(this.change_events, function () {
        that.change();
      });

      this.$element.blur(function () {
        that.$container.addClass(that.container_blured_class);
      });

      var id = this.$element.attr('id');

      if (!this.$label && id) {
        this.$label = $("[for='" + xP.taint_css(id) + "']");
      }

      if (this.$container == this.$element) {
        this.$container = this.$container.add(this.$label);
      }

      if (this.allow_chars_pattern) {
        this.$element.keypress(function (ev) {
          if (
            ev.charCode
            && !(ev.metaKey || ev.ctrlKey || ev.altKey)
            && !String.fromCharCode(ev.charCode).match(
              that.allow_chars_pattern
            )
          ) {
            return false;
          }
        });
      }

      xP.controls._field.base.change.apply(this);
    },

    change_events: 'keyup input change',
    container_blured_class: 'blured',

    destroy: function (handler, remove) {
      if (!arguments.length) {
        this.$label = null;
      }

      return xP.controls._field.base.destroy.apply(this, arguments);
    },

    change: function (handler, remove) {
      if (!arguments.length) {
        var that = this,
          changed = false,
          old = this._param('value'),
          cur = this.val();

        if (old != cur) {
          changed = true;
          this._param('value', cur);
        }

        if (changed) {
          return xP.controls._field.base.change.apply(
            this,
            arguments
          );
        } else {
          return this;
        }
      } else {
        return xP.controls._field.base.change.apply(this, arguments);
      }
    },

    val: function (value) {
      if (!arguments.length) {
        return this.disabled ? undefined : this.$element.val();
      } else {
        var el = this.$element[0];

        if (this.$element.is(':focus')) {
          var start = el.selectionStart,
            end = el.selectionEnd;
        }

        if (el.value != value) {
          el.value = value;

          if (this.$element.is(':focus')) {
            el.selectionStart = start;

            el.selectionEnd = end;
          }

          this.change();
        }

        return this;
      }
    }
  }
};



/*****************
 ** WEBPACK FOOTER
 ** ./lib/controls/_field.js
 ** module id = 4
 ** module chunks = 0
 **/